import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'

const useStyles = makeStyles(() => ({
  card: {
    border: '1px solid var(--color-danger-300, #fca5a5)',
    borderRadius: 'var(--border-radius-lg)',
    backgroundColor: 'var(--color-danger-050, #fef2f2)',
    padding: 'var(--padding-md)',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  heading: {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--gap-sm)',
    fontSize: 'var(--text-size-sm)',
    fontWeight: 700,
    color: 'var(--color-danger-700, #b91c1c)',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    fontSize: 'var(--text-size-xs)',
    color: 'var(--color-danger-700, #b91c1c)',
    lineHeight: 1.5
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '40px 80px minmax(0, 1fr) auto',
    gap: '8px',
    alignItems: 'center'
  },
  index: {
    fontFamily: 'var(--font-mono, monospace)',
    color: 'var(--color-danger-700, #b91c1c)',
    fontWeight: 600
  },
  status: {
    color: 'var(--color-danger-700, #b91c1c)',
    fontWeight: 600
  },
  message: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    fontFamily: 'var(--font-mono, monospace)',
    fontSize: '11px'
  },
  threadIcon: {
    display: 'inline-flex',
    color: 'var(--color-danger-700, #b91c1c)'
  },
  iconSize: {
    fontSize: 14
  }
}))

function ErroredSamplesCard ({ samples }) {
  const classes = useStyles()
  if (!samples?.length) return null

  return (
    <div className={classes.card}>
      <div className={classes.heading}>
        {samples.length} errored sample{samples.length === 1 ? '' : 's'}
      </div>
      <div className={classes.list}>
        {samples.map(s => (
          <div key={s.batchTaskId} className={classes.row}>
            <span className={classes.index}>#{s.sampleIndex}</span>
            <span className={classes.status}>{s.status}</span>
            <span className={classes.message} title={s.judgeError || s.lastError || ''}>
              {s.judgeError || s.lastError || 'unknown error'}
            </span>
            {s.threadId && (
              <a
                href={`/denali-ai/chat/${s.threadId}`}
                target='_blank'
                rel='noreferrer'
                className={classes.threadIcon}
              >
                <OpenInNewIcon className={classes.iconSize} />
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

ErroredSamplesCard.propTypes = {
  samples: PropTypes.array
}

export default ErroredSamplesCard
